const CardBoardLifeCycle = {

    componentDidMount() {
        const { fetchCardsList } = this.props;
        fetchCardsList();
    },
}

export default CardBoardLifeCycle;
